import { uiActions } from "./Ui-slice";
import { cartActions } from "./cart-slice";
import axios from "axios";
import { baseURL } from "../basics";
import useCartItemsAreEqual from "../components/Hooks/useCartItemsAreEqual";
export const fetchCartData: any = (Token: any) => {
  return async (dispatch: any) => {
    const fetchData = async () => {
      const response = await fetch(
        `${baseURL}api/Cart/GetCart?access_token=${Token}`
      );

      if (!response.ok) {
        throw new Error("Could not fetch cart data!");
      }

      const data = await response.json();

      return data;
    };

    try {
      const cartData = await fetchData();
     
      let totalPrice = 0;
      cartData.items.map((item: any) =>
        item.product.price === item.product.discountedPrice
          ? (totalPrice = totalPrice + item.product.price * item.quantity)
          : (totalPrice =
              totalPrice + item.product.discountedPrice * item.quantity)
      );
      let totalQuantity = 0;
      cartData.items.map(
        (item: any) => (totalQuantity = totalQuantity + item.quantity)
      );
      const totalDiscountedPrice = cartData.totalDiscountedAmount;

      dispatch(
        cartActions.replaceCart({
          cartState: {
            cartData,
            totalPrice,
            totalQuantity,
            totalDiscountedPrice,
          } || {
            cartData: { items: [] },
            totalPrice: 0,
            totalQuantity: 0,
            totalDiscountedPrice: 0,
          },
        })
      );
      dispatch(cartActions.compareServerAndLocalItems(true))
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "خطا!",
          message: "دریافت سبد خرید از سرور موفق نبود ",
        })
      );
    }
  };
};

export const sendCartData: any = (cart: any, Token: any) => {
  return async (dispatch: any) => {
    let sendCartItems: any = { couponCode: null, items: [] };

    const newItems = cart.items.items?.filter(
      (item: any) => item.quantity !== 0
    );
    // console.log("newItems", newItems);
    if (newItems.length !== 0) {
      newItems.map((item: any) => {
        return sendCartItems.items.push({
          productId: item.product.id,
          quantity: item.quantity,
        });
      });
    } else {
      // sendCartItems.items = [{quantity: 0 }];
      // console.log("newItems", newItems);
      // console.log("sendCartItems", sendCartItems);
    }
    // console.log("sendCartItems", sendCartItems);

    axios({
      method: "post",
      url: `${baseURL}api/Cart/AddCart?access_token=${Token}`,
      data: sendCartItems,
      headers: { "Content-Type": " application/json" },
    })
      .then((response: any) => {
        dispatch(cartActions.receivedData(true));
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
};

export const sendCartDataForCouponCode: any = (
  cart: any,
  coupon: any,
  Token: any
) => {
  return async (dispatch: any) => {
    let sendCartItems: any = { couponCode: coupon, items: [] };
    const newItems = cart.items.items?.filter(
      (item: any) => item.quantity !== 0
    );

    newItems?.map((item: any) => {
      return sendCartItems.items.push({
        productId: item.product.id,
        quantity: item.quantity,
      });
    });
    coupon
      ? dispatch(
          uiActions.showNotification({
            status: "pending",
            title: "درحال بررسی کد تخفیف شما",
            message: "",
          })
        )
      : dispatch(
          uiActions.showNotification({
            status: "pending",
            title: "درحال لغو کد تخفیف شما",
            message: "",
          })
        );
    axios({
      method: "post",
      url: `${baseURL}api/Cart/AddCart?access_token=${Token}`,
      data: sendCartItems,
      headers: { "Content-Type": " application/json" },
    })
      .then((response: any) => {
        const totalDiscountedAmount = response.data.totalDiscountedAmount;
        dispatch(
          cartActions.changeTotalDiscountedAmountAfterAddingCoupon(
            totalDiscountedAmount
          )
        );
        coupon
          ? dispatch(cartActions.toggleCouponButton(false))
          : dispatch(cartActions.toggleCouponButton(true));
        coupon
          ? dispatch(
              uiActions.showNotification({
                status: "success",
                title: "کد تخفیف اعمال شد",
                message: "",
              })
            )
          : dispatch(
              uiActions.showNotification({
                status: "success",
                title: "کد تخفیف شما لغو شد",
                message: "",
              })
            );
      })
      .catch((error: any) => {
        coupon
          ? dispatch(
              uiActions.showNotification({
                status: "error",
                title: "کد تخفیف تایید نشد",
                message: error.response.data,
              })
            )
          : dispatch(
              uiActions.showNotification({
                status: "error",
                title: "کد تخفیف لغو نشد",
                message: error.response.data,
              })
            );
        // console.log("error", error.response.data);
      });
  };
};

export const fetchFavoriteCartData: any = (Token: any) => {
  return async (dispatch: any) => {
    const fetchFavoriteData = async () => {
      const response = await fetch(
        `${baseURL}api/User/GetFavoriteProducts?access_token=${Token}`
      );

      if (!response.ok) {
        throw new Error("Could not fetch cart data!");
      }

      const data = await response.json();
      //console.log("fetchFavoriteData::", data);
      //  benazaram in data bayad ba map() check shavad k be ezaye har id k
      //  daryaft mikonim product an ra peyda konim, chon in data etelaate
      //  kameli product ra nadarad.
      return data;
    };

    try {
      const favoriteCartData = await fetchFavoriteData();
      // handle totalPrice by any fetch request

      // let totalPrice = 0;
      // favoriteCartData.items.map(
      //   (item: any) =>
      //     (totalPrice = totalPrice + item.product.price * item.quantity)
      // );
      dispatch(uiActions.fetchingFavoriteDataIssuccessfull(true));
      dispatch(
        cartActions.replaceFavoriteCart({
          favoriteCartState: { favoriteCartData } || {
            favoriteCartData: [],
          },
        })
      );
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "خطا!",
          message: "برای ایجاد مورد علاقه باید ابتدا لاگین کنید",
        })
      );
    }
  };
};

export const sendFavoriteCartData: any = (id: any, Token: any) => {
  return async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("ProductId", id);
    //console.log("sendfavoriteCartData", id);
    axios({
      method: "post",
      url: `${baseURL}api/User/AddFavoriteProduct?access_token=${Token}`,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  };
};
